export const validateExternalUrl = (href: string) => {
  if (!href) {
    return;
  }

  if (href.startsWith('http')) {
    return href;
  }

  if (href.startsWith('/')) {
    return href;
  }

  return `https://${href}`;
};

/**
 * Sets `embed=true` on cross-app profile/shop links when embed mode is active.
 * Uses {@link URL#searchParams} (or {@link URLSearchParams} in the relative-URL
 * fallback) so an existing `embed` query is replaced, not duplicated.
 * Preserves other query params and URL fragments.
 */
export const appendEmbedToExternalHref = (
  href: string | undefined,
  embed: boolean | undefined
): string | undefined => {
  if (!href || embed !== true) {
    return href;
  }
  try {
    const url = new URL(href);
    url.searchParams.set('embed', 'true');
    return url.toString();
  } catch {
    const hashIndex = href.indexOf('#');
    const beforeHash = hashIndex === -1 ? href : href.slice(0, hashIndex);
    const hash = hashIndex === -1 ? '' : href.slice(hashIndex);
    const qIndex = beforeHash.indexOf('?');
    const path = qIndex === -1 ? beforeHash : beforeHash.slice(0, qIndex);
    const queryString = qIndex === -1 ? '' : beforeHash.slice(qIndex + 1);
    const params = new URLSearchParams(queryString);
    params.set('embed', 'true');
    return `${path}?${params.toString()}${hash}`;
  }
};
